export default {
  'Advertising/Marketing': [
    'Advertising Agencies',
    'Advertising/Marketing (General)',
    'Broadcasting - Radio',
    'Broadcasting - TV',
    'Communications',
    'Entertainment',
    'Event Management',
    'Marketing Services',
    'Movie Production/Theaters',
    'PR',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Aerospace/Aviation': [
    'Aerospace/Aviation (General)',
    'Air Services',
    'Major Airlines',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Automotive: [
    'Auto Dealerships',
    'Auto Manufacturers',
    'Automotive (General)',
    'Recreational Vehicles',
    'Trucks/Other Vehicles',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Biotech and Pharmaceuticals': [
    'Biotech and Pharmaceuticals (General)',
    'Clinical Laboratory',
    'Life Sciences Manufacturing',
    'Pharmaceuticals',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Computers and Technology': [
    'Computer Hardware',
    'Computer Networking',
    'Computer Software',
    'Computer/Network Security',
    'Computers and Technology (General)',
    'Information Technology/Services',
    'Internet',
    'Nanotechnology',
    'Semiconductors',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Corporate Services': [
    'Business Supplies/Equipment',
    'Corporate Services (General)',
    'E-Learning',
    'Human Resources',
    'Legal Services',
    'Management Consulting',
    'Market Research',
    'Outsourcing/Offshoring',
    'Professional Training',
    'Program Development',
    'Staffing/Recruiting',
    'Translation/Localization',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Education: [
    'E-Learning',
    'Education (General)',
    'Education Management',
    'Higher Education',
    'K-12',
    'Research',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Finance: [
    'Accounting',
    'Banking',
    'Capital Markets',
    'Credit Unions',
    'Finance (General)',
    'Financial Services',
    'Investment Banking/Venture',
    'Investment Management',
    'Venture Capital',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Government: [
    'Department of Defense (Civilian)',
    'Department of Defense (Military)',
    'Federal Government',
    'Government (General)',
    'Government Contractor',
    'Private Sector',
    'State/Local Government',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Healthcare/Medical': [
    'Alternative Medicine',
    'Health/Wellness/Fitness',
    'Healthcare/Medical (General)',
    'Hospital/Healthcare',
    'Veterinary',
    'Healthcare Policy',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Insurance: ['Automotive', 'Health', 'Insurance (General)', 'Other'].map((item) => ({
    label: item,
    value: item,
  })),
  Legal: ['Corporate Legal', 'Law Practice', 'Legal (General)', 'Legal Services', 'Other'].map(
    (item) => ({ label: item, value: item })
  ),
  Media: [
    'Audio/Music',
    'Broadcast Media',
    'Computer Games',
    'Design',
    'Graphic Design',
    'Information Services',
    'Media (General)',
    'Media Production',
    'Motion Pictures/Film',
    'Newspapers',
    'Online Publishing',
    'Publishing',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Non-Profit/Organizations': [
    'Alternative Dispute Resolution',
    'Civic/Social Organization',
    'Consumer Services',
    'Environmental Services',
    'Fundraising',
    'Individual/Family Services',
    'Non-Profit Organization Management',
    'Philanthropy',
    'Political Organization',
    'Program Development',
    'Religious Institutions',
    'Security / Investigations',
    'Think Tanks',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Retail and Consumer Goods': [
    'Apparel/Fashion',
    'Consumer Electronics',
    'Retail and Consumer Goods (General)',
    'Wholesale',
    'eCommerce',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Telecommunications: [
    'Satellite Telecommunications',
    'Telecom Services - Domestic',
    'Telecom Services - Foreign',
    'Telecommunications (General)',
    'Wired Telecommunications Carriers',
    'Wireless Communications',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Transportation and Logistics': [
    'Import/Export',
    'International Trade/Development',
    'Logistics/Supply Chain',
    'Maritime',
    'Package/Freight Delivery',
    'Transportation and Logistics (General)',
    'Transportation/Trucking/Railroad',
    'Warehousing',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Travel/Hospitality/Entertainment': [
    'Entertainment',
    'Gambling/Casinos',
    'Music',
    'Sports',
    'Travel/Hospitality/Entertainment (General)',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Utility/Energy': [
    'Gas',
    'Nuclear',
    'Power Distributors',
    'Power Generation',
    'Renewable Energy',
    'Utility/Energy (General)',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Other: ['Other'].map((item) => ({ label: item, value: item })),
};
